export const goToUrl = (url: string): void => {
  window.location.href = url;
};
